import { makeAutoObservable, runInAction } from 'mobx';

/**
 * Renderer mirror of the Terminal integration opt-in persisted by Electron
 * main. Main is the source of truth (it gates PTY access and re-advertises
 * the toolkit); this store exists so the settings badge, the configuration
 * tab, and connect/disconnect actions all observe one value without each
 * round-tripping IPC.
 */
export class TerminalIntegrationStore {
  enabled = false;
  loaded = false;
  pending = false;

  constructor() {
    makeAutoObservable(this);
  }

  async load(): Promise<void> {
    const { electronApis } = await import('@/features/electron-api');
    const enabled = await electronApis.localTerminal.getIntegrationEnabled();
    runInAction(() => {
      this.enabled = enabled;
      this.loaded = true;
    });
  }

  async setEnabled(enabled: boolean): Promise<void> {
    if (this.pending) return;
    runInAction(() => {
      this.pending = true;
    });
    try {
      const { electronApis } = await import('@/features/electron-api');
      await electronApis.localTerminal.setIntegrationEnabled(enabled);
      runInAction(() => {
        this.enabled = enabled;
        this.loaded = true;
      });
    } finally {
      runInAction(() => {
        this.pending = false;
      });
    }
  }
}

export const terminalIntegrationStore = new TerminalIntegrationStore();
